import { ConnectionName, mapConnectionUIName } from "@arelia-types/connection";
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, Typography } from "@mui/material";
import { useContext } from "react";
import theme from "src/theme";
import ConnectionsContext from "../../ConnectionsContext";
import { useInactiveConnections } from "../../hooks";

type Props = {
  open: boolean;
  onClose: () => void;
}

export default function AddConnectionDialog({ open, onClose }: Props) {
  const inactiveConnections = useInactiveConnections();
  const { activeConnections, setActiveConnections } = useContext(ConnectionsContext);

  const addConnection = (name: ConnectionName) => {
    if (!activeConnections.includes(name)) {
      setActiveConnections([...activeConnections, name]);
    }
  };

  return <Dialog onClose={onClose} open={open} maxWidth={'lg'}>
    <DialogTitle>
      Add new Connection
    </DialogTitle>
    <DialogContent dividers={true}>
      <List>
        {inactiveConnections.map(({name, icon, type}, index) => (
          <ListItem divider={index !== inactiveConnections.length -1} key={index} sx={styles.listItem}>
            <Box sx={styles.name}>
              <Avatar src={icon} sx={styles.avatar} imgProps={{ sx: styles.imgProps }}/>
              {mapConnectionUIName(name)}
            </Box>
            <Box sx={styles.info}>
              <Typography sx={styles.type}>{type?.join(', ')}</Typography>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => addConnection(name)}
              >
                Add
              </Button>
            </Box>
          </ListItem>
        ))}
      </List>
    </DialogContent>
    <DialogActions sx={styles.dialogActions}>
      <Button
        variant="text"
        color="secondary"
        onClick={() => onClose()}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
}

const styles = {
  name: { display: "flex", alignItems: "center", gap: "20px", paddingLeft: "5px" },
  avatar: {
    borderRadius: "50%",
    width: 30,
    height: 30,
  },
  imgProps: { objectFit: "contain" },
  info: { display: "flex", gap: "40px", alignItems: "center" },
  type: { minWidth: "80px", color: theme.palette.grey[700], textTransform: "uppercase", fontSize: "12px" },
  listItem: { justifyContent: "space-between" },
  dialogActions: { padding: "15px 10px" }
}